

import { get } from 'lodash';

import Spa from '@assets/images/amenities/spa.png';
import Air from '@assets/images/amenities/air.png';
import Restaurant from '@assets/images/amenities/restaurant.png';
import Beakfast from '@assets/images/amenities/breakfast.png';
import Parking from '@assets/images/amenities/parking.png';
import RoomService from '@assets/images/amenities/room-service.png';
import FrontDesk from '@assets/images/amenities/front-desk.png';
import Pool from '@assets/images/amenities/pool.png';
import Wifi from '@assets/images/amenities/wifi.png';
import FreeWifi from '@assets/images/amenities/free-wifi.png';
import Gym from '@assets/images/amenities/gym.png';
import BusinessService from '@assets/images/amenities/business-service.png';
import Bar from '@assets/images/amenities/bar.png';
import Housekeeping from '@assets/images/amenities/housekeeping.png';
import PetFriendly from '@assets/images/amenities/pet-friendly.png';
import Laundry from '@assets/images/amenities/laundry.png';
import NonSmokingRooms from '@assets/images/amenities/non-smoking-rooms.png';
import FacilitiesDisabledGuests from '@assets/images/amenities/facilities-disabled-guests.png';
import Beakfast2 from '@assets/images/amenities/breakfast-2.png';
import SpaCredit from '@assets/images/amenities/spa-credit.png';
import CasinoCredit from '@assets/images/amenities/casino-credit.png';
import FreeMassage from '@assets/images/amenities/free-massage.png';
import FreeMinibar from '@assets/images/amenities/free-minibar.png';
import BuffetDinner from '@assets/images/amenities/buffet-dinner.png';
import IroningBoard from '@assets/images/amenities/ironing-board.png';
import Kitchenette from '@assets/images/amenities/kitchenette.png';
import HairDryer from '@assets/images/amenities/hair-dryer.png';
import HeatedGuestRooms from '@assets/images/amenities/heated-guest-rooms.png';
import DVDRental from '@assets/images/amenities/dvd-rental.png';
import ATM from '@assets/images/amenities/atm.png';
import FrontDesk24 from '@assets/images/amenities/front-desk-24.png';
import FreeShuttle from '@assets/images/amenities/free-shuttle.png';
import FreeParking from '@assets/images/amenities/free-parking.png';
import IceMachine from '@assets/images/amenities/ice-machine.png';
import Jacuzzi from '@assets/images/amenities/jacuzzi.png';
import Playground from '@assets/images/amenities/playground.png';
import SafeDepositBox from '@assets/images/amenities/safe-deposit-box.png';
import PetAmenities from '@assets/images/amenities/pet-amenities.png';
import PetsAllowed from '@assets/images/amenities/pets-allowed.png';
import TennisCourt from '@assets/images/amenities/tennis-court.png';

import Locations from '@assets/images/amenities/location.svg';
import Elevator from '@assets/images/amenities/elevator.svg';
import Recycling from '@assets/images/amenities/recycle.svg';
import Golf from '@assets/images/amenities/golf.svg';
import Wheelchair from '@assets/images/amenities/wheelchair.svg';
import Water from '@assets/images/amenities/water.svg';
import ElectricCharging from '@assets/images/amenities/electric-charging.svg';
import HandFlower from '@assets/images/amenities/hand-flower.svg';
import LuggageStorage from '@assets/images/amenities/luggage-storage.svg';
import Bellhop from '@assets/images/amenities/bellhop.svg';
import Lounge from '@assets/images/amenities/lounge.svg';
import Fireplace from '@assets/images/amenities/fireplace.svg';
import GiftShop from '@assets/images/amenities/gift-shop.svg';
import Wedding from '@assets/images/amenities/wedding.svg';
import Ski from '@assets/images/amenities/ski.svg';
import PetsNotAllowed from '@assets/images/amenities/no-pets.svg';
import Staff from '@assets/images/amenities/staff.svg';
import Garden from '@assets/images/amenities/garden.svg';
import Terrace from '@assets/images/amenities/terrace.svg';
import Computer from '@assets/images/amenities/computer.svg';

import { IAmenities } from '@common-types';

const AMENITIES_MAPPING: any[] = [
  { id: 1, name: 'Spa', image: Spa },
  { id: 2, name: 'Air conidtioning', image: Air },
  { id: 3, name: 'Restaurant', image: Restaurant },
  { id: 4, name: 'Breakfast available', image: Beakfast }, 
  { id: 5, name: 'Parking available', image: Parking },
  { id: 5, name: 'Uncovered parking', image: Parking },
  { id: 5, name: 'Free RV, bus, truck parking', image: Parking },
  { id: 5, name: 'Wheelchair accessible parking', image: Parking },
  { id: 5, name: 'Wheelchair-accessible van parking', image: Parking },
  { id: 5, name: 'Free self parking', image: FreeParking },
  { id: 6, name: 'Room service', image: RoomService },
  { id: 7, name: '24/7 front desk', image: FrontDesk },
  { id: 8, name: 'Pool', image: Pool },
  { id: 8, name: 'Wheelchair-accessible pool', image: Pool },
  { id: 8, name: ' Swimming pool', image: Pool },
  { id: 9, name: 'Wifi', image: Wifi },
  { id: 10, name: 'Free Wifi', image: FreeWifi },
  { id: 11, name: 'Gym', image: Gym },
  { id: 12, name: 'Business services', image: BusinessService },
  { id: 13, name: 'Bar', image: Bar },
  { id: 14, name: 'Housekeeping', image: Housekeeping },
  { id: 15, name: 'Pet friendly', image: PetFriendly },
  { id: 16, name: 'Laundry', image: Laundry },
  { id: 17, name: 'Non-smoking rooms', image: NonSmokingRooms },
  { id: 18, name: 'Facilities for disabled guests', image: FacilitiesDisabledGuests },
  { id: -1, name: 'Breakfast for 2', image: Beakfast2 },
  { id: -1, name: 'Spa Credit', image: SpaCredit },
  { id: -1, name: 'Casino credit', image: CasinoCredit },
  { id: -1, name: 'Free massage included', image: FreeMassage },
  { id: -1, name: 'Free minibar', image: FreeMinibar },
  { id: -1, name: 'Buffet dinner', image: BuffetDinner },
  { id: 256, name: 'Ironing Board', image: IroningBoard },
  { id: 277, name: 'Kitchenette', image: Kitchenette },
  { id: 255, name: 'Hair Dryer', image: HairDryer },
  { id: 257, name: 'Heated Guest Rooms', image: HeatedGuestRooms },
  { id: 199, name: 'DVD Video Rental', image: DVDRental },
  { id: 27, name: 'ATM Cash Machine', image: ATM },
  { id: 27, name: 'ATM/banking', image: ATM },
  { id: 27, name: 'Concierge services', image: FrontDesk },
  { id: 22, name: 'Front Desk 24 Hour', image: FrontDesk24 },
  { id: 22, name: '24-hour front desk', image: FrontDesk24 },
  { id: 61, name: 'Free Airport Shuttle', image: FreeShuttle },
  { id: 61, name: 'Pet max weight (per pet) in lb is 75', image: PetsAllowed },
  { id: 61, name: 'Only dogs and cats are allowed', image: PetsAllowed },
  { id: 61, name: 'Pet max weight (per pet) in kg is 34', image: PetsAllowed },
  { id: 61, name: 'Service animals are allowed', image: PetsAllowed },
  { id: 61, name: 'Service animals are exempt from fees/restrictions', image: PetsAllowed },
  { id: 61, name: 'Maximum number of pets per room 2', image: PetsAllowed },
  { id: 61, name: 'Safe-deposit box at front desk', image: SafeDepositBox },
  { id: 61, name: 'Smoke-free property', image: NonSmokingRooms },
  { id: 62, name: 'Free Parking', image: FreeParking },
  { id: 72, name: 'Ice Machine', image: IceMachine },
  { id: 75, name: 'Jacuzzi', image: Jacuzzi },
  { id: 90, name: 'Playground', image: Playground },
  { id: 95, name: 'Safe Deposit Box', image: SafeDepositBox },
  { id: 164, name: 'Front Desk', image: FrontDesk },
  { id: 230, name: 'Pet Amenities Available', image: PetAmenities },
  { id: 240, name: 'Pets Allowed', image: PetsAllowed },
  { id: 248, name: 'Tennis Court', image: TennisCourt },
  { id: 248, name: 'Wheelchair-accessible on-site restaurant', image: Restaurant },
  { id: 248, name: 'Dry cleaning/laundry service', image: Laundry },
  { id: 248, name: 'Housekeeping on request', image: Housekeeping },
  { id: 248, name: 'Conference space', image: BusinessService },
  { id: 248, name: 'Wheelchair accessible (may have limitations)', image: FacilitiesDisabledGuests },
  { id: 248, name: 'Wheelchair-accessible fitness center', image: Gym },
  { id: 248, name: 'Wheelchair-accessible registration desk', image: FrontDesk },
  { id: 248, name: 'Change of bed sheets (on request)', image: Housekeeping },
  { id: 248, name: 'Meeting rooms', image: BusinessService },
  { id: 248, name: 'Swimming pool', image: Pool },
  { id: 248, name: 'Wheelchair accessible path of travel', image: FacilitiesDisabledGuests },
  { id: 248, name: 'Health or beauty spa nearby', image: Spa },
  { id: 248, name: 'Ziplining nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Mountain climbing nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Rafting nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Sailing nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Self parking (surcharge)', image: Parking },
  { id: 248, name: 'Pets not allowed', image: PetsNotAllowed, isSVG: true },
  { id: 248, name: 'Segway rental/tour nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Scooter/moped rentals nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Parasailing nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Windsurfing nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Sailing nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Skydiving nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Scuba diving nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Water skiing nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Boat tours nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Surfing/bodyboarding nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Multilingual staff', image: Staff, isSVG: true },
  { id: 248, name: 'Game viewing nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Terrace', image: Terrace, isSVG: true },
  { id: 248, name: 'Bicycle rentals nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Computer station', image: Computer, isSVG: true },

  { id: 248, name: 'Front desk (limited hours)', image: FrontDesk },
  { id: 248, name: 'Parking (limited spaces)', image: Parking },
  { id: 248, name: 'Wheelchair-accessible path to elevator', image: Elevator, isSVG: true },
  { id: 248, name: 'Garden', image: Garden, isSVG: true },

  { id: 248, name: 'Mountain biking nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Casino nearby', image: CasinoCredit },
  { id: 248, name: 'Rock climbing nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Kayaking nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Hiking/biking trails nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Change of towels (on request)', image: Housekeeping },
  { id: 248, name: 'Spa services on site', image: Spa },
  { id: 248, name: 'Valet parking (surcharge)', image: Parking },
  { id: 248, name: 'Only dogs are allowed', image: PetsAllowed },
  { id: 248, name: 'Covered parking', image: Parking },
  { id: 248, name: 'Laundry facilities', image: Laundry },
  { id: 248, name: 'Breakfast available (surcharge)', image: Beakfast },
  { id: 248, name: 'Vegetarian breakfast available', image: Beakfast },
  { id: 248, name: 'RV, bus, truck parking (surcharge)', image: Parking },
  { id: 248, name: 'Wheelchair-accessible concierge desk', image: FrontDesk },
  { id: 248, name: 'Spa treatment room(s)', image: Spa },
  { id: 248, name: 'Full-service spa', image: Spa },
  { id: 248, name: 'Spa services on site', image: Spa },
  { id: 248, name: 'Valet parking (surcharge)', image: Parking },
  { id: 248, name: 'Only dogs are allowed', image: PetsAllowed },
  { id: 248, name: 'Covered parking', image: Parking },
  { id: 248, name: 'Laundry facilities', image: Laundry },
  { id: 248, name: 'Breakfast available (surcharge)', image: Beakfast },
  { id: 248, name: 'Vegetarian breakfast available', image: Beakfast },
  { id: 248, name: 'RV, bus, truck parking (surcharge)', image: Parking },
  { id: 248, name: 'Elevator', image: Elevator, isSVG: true },
  { id: 248, name: 'Recycling', image: Recycling, isSVG: true },
  { id: 248, name: 'Recycling available', image: Recycling, isSVG: true },
  { id: 248, name: 'Comprehensive recycling policy', image: Recycling, isSVG: true },
  { id: 248, name: 'Express check-out', image: FrontDesk },
  { id: 248, name: 'Water-efficient showers only', image: HandFlower, isSVG: true },
  { id: 248, name: 'Energy-saving switches', image: HandFlower, isSVG: true },
  { id: 248, name: 'At least 80% of all lighting comes from LEDs', image: HandFlower, isSVG: true },
  { id: 248, name: 'Luggage storage', image: LuggageStorage, isSVG: true },
  { id: 248, name: 'Water-efficient showers only', image: HandFlower, isSVG: true },
  { id: 248, name: 'Porter/bellhop', image: Bellhop, isSVG: true },
  { id: 248, name: 'Wheelchair-accessible lounge', image: Lounge, isSVG: true },
  { id: 248, name: 'Fireplace in lobby', image: Fireplace, isSVG: true },
  { id: 248, name: 'Gift shops or newsstand', image: GiftShop, isSVG: true },
  { id: 248, name: 'No single-use plastic stirrers', image: HandFlower, isSVG: true },
  { id: 248, name: 'No single-use plastic straws', image: HandFlower, isSVG: true },
  { id: 248, name: 'Wedding services', image: Wedding, isSVG: true },
  { id: 248, name: 'Ski lessons available nearby', image: Ski, isSVG: true },
  { id: 248, name: 'Ski equipment rental shops nearby', image: Ski, isSVG: true },
  { id: 248, name: 'Cross-country skiing nearby', image: Ski, isSVG: true },
  { id: 248, name: 'Downhill skiing nearby', image: Ski, isSVG: true },
  { id: 248, name: 'Pets allowed (no fees)', image: PetsAllowed },
  { id: 248, name: 'Pets cannot be left unattended', image: PetsNotAllowed, isSVG: true },
  { id: 248, name: 'Pet max weight (per pet) in kg is 18', image: PetsAllowed },
  { id: 248, name: 'Pet max weight (per pet) in lb is 25', image: PetsAllowed },
  { id: 248, name: 'Pet max weight (per pet) in lb is 40', image: PetsAllowed },
  { id: 248, name: 'Pet max weight (per pet) in kg is 11', image: PetsAllowed },
  { id: 248, name: 'Maximum number of pets per room 1', image: PetsAllowed },
  { id: 248, name: 'Ecotours nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Snorkeling nearby', image: Locations, isSVG: true },
  { id: 248, name: 'Rooftop terrace', image: Terrace, isSVG: true },
  { id: 248, name: 'Pool access ramp on site', image: Pool },
  { id: 248, name: 'Front entrance ramp', image: Wheelchair, isSVG: true },
  

  { id: 248, name: 'Golf lessons available nearby', image: Golf, isSVG: true },
  { id: 248, name: 'Golfing nearby', image: Golf, isSVG: true },
  { id: 248, name: 'Biodegradable/compostable stirrers', image: Recycling, isSVG: true },
  { id: 248, name: 'Wheelchairs available on site', image: Wheelchair, isSVG: true },
  { id: 248, name: 'Water dispenser', image: Water, isSVG: true },
  { id: 248, name: 'Electric car charging station', image: ElectricCharging, isSVG: true },

  { id: 248, name: 'Free airport transportation', image: FreeShuttle },
  { id: 248, name: 'Children\'s pool', image: Pool },
  { id: 248, name: 'Outdoor space', image: Locations, isSVG: true },

  { id: 86, name: 'Outdoor Pool', image: Pool },
  { id: 360, name: 'Fitness Center', image: Gym },
  { id: 360, name: 'Fitness facilities', image: Gym },
  { id: 42, name: 'Concierge Desk', image: FrontDesk },
  { id: 78, name: 'Laundry Valet Service', image: Laundry },
  { id: 244, name: 'Business Center', image: BusinessService },
  { id: 248, name: 'Wheelchair-accessible meeting spaces/business center', image: BusinessService },
  { id: 70, name: 'Housekeeping Daily', image: Housekeeping },
  { id: 327, name: 'Smoke Free Property', image: NonSmokingRooms },
  { id: 301, name: 'Complimentary Wireless Internet', image: Wifi },
  { id: 181, name: 'Lounges Bars', image: Bar },
];


export const getAmenityImage = (amenity: IAmenities) => {
  const imageByName = getAmenityImageByName(amenity.name);
  const imageById = get(AMENITIES_MAPPING.filter(a => a.id === amenity.amenityId), '[0]', null);
  const response = imageByName || imageById;
  return response || {} as any;
}

export const getAmenityImageByName = (amenityName: string) => {
  return get(AMENITIES_MAPPING.filter(a => a.name?.toLowerCase() === amenityName?.toLowerCase()), '[0]', null);
}